import { render, staticRenderFns } from "./IntegrationNewConfig.vue?vue&type=template&id=51c925a7&"
import script from "./IntegrationNewConfig.vue?vue&type=script&lang=js&"
export * from "./IntegrationNewConfig.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationNewConfig.vue?vue&type=style&index=0&id=51c925a7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports